<template>
  <div>
    <v-card-actions>
      <small class="caption">* Requerido</small>
    </v-card-actions>
    <v-progress-linear
      color="blue"
      indeterminate
      v-if="loading"
    ></v-progress-linear>
  </div>
</template>

<script>
export default {
  name: "pieCrud",
  props: ["loading"]
};
</script>
